import { motion } from "framer-motion";
import { fadeUp, staggerWrap } from "./shared";

export const SectionHead = ({ eyebrow, title, id, light = false }) => (
    <motion.div
        variants={staggerWrap}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.15 }}
        className="mb-12 md:mb-16"
        data-testid={`section-head-${id}`}
    >
        <motion.p variants={fadeUp} className="eyebrow mb-4 flex items-center gap-3">
            <span className="inline-block h-px w-8 bg-aqua" />
            {eyebrow}
        </motion.p>
        <motion.h2
            variants={fadeUp}
            className={`font-display font-bold tracking-tight leading-[1.05] text-2xl sm:text-3xl lg:text-4xl ${
                light ? "text-bitume" : "text-cloud"
            }`}
        >
            {title}
        </motion.h2>
    </motion.div>
);
